import PropTypes from 'prop-types';
import React from 'react';

const Progress = ({ current, total }) => (
  <p className="text-gray-50" data-testid="idea-progress">
    {current} out of {total}
  </p>
);
Progress.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number
};

export default Progress;
